import { getGraphqlErrorMessage } from '../graphql/graphqlErrors';

export function getErrorProps(error) {
  return {
    text: 'Произошла ошибка',
    description: getGraphqlErrorMessage(error)
  };
}
